import { Navigate, useRoutes } from 'react-router-dom';
// layouts
// import MainLayout from 'src/layouts/main';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { mainRoutes, HomePage } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';
// import { JwtLoginView } from "src/sections/auth/jwt";
import AuthClassicLayout from "./../../layouts/auth/classic";
import { userRoutes } from './user-routes';
import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export default function Router() {
  const { user } = useAuthContext()

  return useRoutes([
    // Redirect to the login page with returnTo parameter set to '/dashboard'
    {
      path: '/',
      element: <Navigate to={user?.role[0]?.name=="admin" ? "/dashboard" : "user-dashboard" }replace />
    },

    // Authenticated routes
    // {
    //   path: 'src/sections/auth/jwt',
    //   element: (
    //     <AuthClassicLayout>
    //       <HomePage />
    //     </AuthClassicLayout>
    //   )
    // },


    // Auth routes
    ...authRoutes,
    ...authDemoRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    ...userRoutes,
    // Components routes
    ...componentsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
